import MagicPropertiesProvider from "./MagicPropertiesProvider";
import VariableChangesProvider from "./variableChangeProvider";

export default {
	__init__: ["magicPropertiesProvider","variableChangesProvider"],
	magicPropertiesProvider: ["type", MagicPropertiesProvider],
	variableChangesProvider: ["type",VariableChangesProvider],
	};
